import { render, staticRenderFns } from "./SignUpPage.vue?vue&type=template&id=a09a011a&scoped=true&"
import script from "./SignUpPage.vue?vue&type=script&lang=js&"
export * from "./SignUpPage.vue?vue&type=script&lang=js&"
import style0 from "./SignUpPage.vue?vue&type=style&index=0&id=a09a011a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09a011a",
  null
  
)

export default component.exports